<template>
	<Modal v-model="modal">
		<div class="wrapper">
			<div
				v-if="!order.id"
				class="flex"
			>
				<TnHeading
					type="h1"
					size="m"
					class="margin-top-xl"
				>
					{{ content.heading }}
				</TnHeading>
				<TnParagraph size="s">{{ content.ageDisclaimer }}</TnParagraph>
				<ECommerceClickAndCollectProductCard />
				<ECommerceClickAndCollectStoreSelector
					v-if="!storeSelected.id"
					:hardware-product-id="product.gtin"
					:content="content.storeSelector"
					@set-selected-store="setSelectedStore"
				/>
				<ECommerceClickAndCollectCustomerForm
					v-else-if="storeSelected.id"
					:store="storeSelected"
					:hardware-product-id="product.id"
					:content="content.customerForm"
					@order-successful="setOrder"
				/>
			</div>
			<ECommerceClickAndCollectOrderConfirmation
				:content="content.orderConfirmation"
				:order="order"
				:store="selectedStore"
				v-else
			/>
		</div>
	</Modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { mapState as mapPiniaState } from "pinia";

export default defineNuxtComponent({
	name: "ECommerceClickAndCollect",

	props: {
		content: {
			type: Object,
		},
	},

	data: () => ({
		modal: false,
		selectedStore: {},
		customer: {},
		order: {},
	}),

	async mounted() {
		if (!this.product.disableClickAndCollect) {
			this.locationPending = true;

			const position = await useGeolocationStore().requestBestAvailablePosition(true);
			this.locationPending = false;
			if (position != null && Object.keys(position).length > 0) {
				await this.getStoresWithProduct({ gtin: this.product.gtin, query: "", location: position });
			} else {
				await this.getStoresWithProduct({ gtin: this.product.gtin, query: "" });
			}
		} else {
			this.setLoadingClickAndCollect(false);
		}
	},

	watch: {
		modal(value) {
			if (!value) {
				this.selectedStore = {};
				this.customer = {};
				this.order = {};
			}

			if (value != this.clickAndCollectModalOpen) this.toggleClickAndCollectModal();
		},
		clickAndCollectModalOpen(value) {
			if (this.modal != value) this.modal = value;
		},
	},

	computed: {
		...mapState("ecommerce", ["clickAndCollectModalOpen", "product", "storeSelected"]),
		...mapPiniaState(useGeolocationStore(), ["position"]),
	},

	methods: {
		...mapMutations("ecommerce", ["toggleClickAndCollectModal", "setLoadingClickAndCollect"]),
		...mapActions("ecommerce", ["getNumberOfStoresWithProduct", "getStoresWithProduct"]),

		setSelectedStore(store) {
			this.selectedStore = store;
			this.$store.commit("ecommerce/setStoreSelected", store);
		},
		setOrder(order) {
			this.order = order;
		},
	},
});
</script>

<style lang="scss" scoped>
.wrapper {
	width: 600px;

	@include breakpoint(mobile) {
		width: initial;
	}
}

.flex {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	gap: 1.5rem;
}
</style>
